<template>
  <v-app id="app" light>
    <v-content>
      <v-container fluid fill-height class="registration-background">
        <v-layout align-center justify-center>
          <v-flex xs12 sm10 md8 lg6>
            <div class="text-xs-center white--text page-title">
              <h1>{{ uiState.pageTitle }}</h1>
              <p>{{ uiState.pageSubtitle }}</p>
            </div>
            <w-card class="elevation-4 registration-card">
              <v-layout align-center justify-center class="header-wrapper">
                <div class="header">
                  <div class="header-container">
                    <div class="card-wrapper">
                      <w-card class="elevation-4">
                      </w-card>
                    </div>
                    <div class="logo">
                      <v-container fluid fill-height>
                        <v-layout align-center justify-center>
                          <img :src="logoUrl" alt="">
                        </v-layout>
                      </v-container>
                    </div>
                  </div>
                </div>
              </v-layout>
              <div class="registration-content mt-3 mb-3">
                <router-view class="pt-3"></router-view>
                <div class="loading" v-if="isLoading">
                  <v-container fluid fill-height>
                    <v-layout align-center justify-center>
                      <v-progress-circular indeterminate :size="70" :width="7" color="blue"></v-progress-circular>
                    </v-layout>
                  </v-container>
                </div>
              </div>
            </w-card>
            <div class="text-xs-center white--text mt-3">
              &copy; Weview {{ year }}
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import wCard from '@/components/generics/WCard';
import rootUrl from '@/../config/root-url';
import { mapState } from 'vuex';

export default {
  name: `App`,
  computed : {
    year () {
      return (new Date()).getFullYear();
    },
    logoUrl () {
      return `${rootUrl}/static/img/just-w.png`;
    },
    ...mapState([
      `uiState`,
    ]),
    ...mapState({
      isLoading : state => state.uiState.isLoading,
    }),
  },
  components : {
    wCard,
  },
  created () {
    this.$store.dispatch(`setPageTitle`, `En route, vous y êtes presque !`);
    this.$store.dispatch(`setPageSubtitle`, `Inscription gratuite à Weview`);
    this.$store.dispatch(`isLoading`);
  },
  mounted () {
    // setTimeout(() => this.$store.dispatch(`isLoading`, false), 1000);
    // this.$store.dispatch(`initMe`)
    // .then(() => this.$store.dispatch(`setCurrentCompany`, this.company))
    // .then(() => {
    //   const company = this.$store.state.uiState.currentCompany.id;
    //   if (!this.$route.params.company) {
    //     return this.$router.push({ name : `Dashboard`, params : { company } });
    //   }

    //   return null;
    // })
    // .then(() => this.$store.dispatch(`fetchDatas`))
    // .then(() => this.$store.dispatch(`datasAvailable`))
    // .then(() => this.initCrisp());
  },
};
</script>

<style lang="scss" scoped>

  .page-title {
    margin-bottom: 80px;

    h1 {
      line-height: 3rem;
      font-size: 3rem;
      font-weight: 500;
      letter-spacing: 0.06rem;
    }

    p {
      margin-top: 20px;
      // font-weight: 500;
      font-size: 2rem;
      opacity: 0.9;
    }
  }

  .w-card.registration-card {
    border: 0px;
    border-radius: 10px;

    .header-wrapper {
      position: relative;
    }

    .header {
      width: 120px;
      height: 120px;
      margin-top: -55px;
      margin-left: -60px;
      position: absolute;
      top: 0px;
      bottom: 0px;
      left: 50%;
      right: 0px;

      .logo {
        position: absolute;
        top: 0px;
        bottom: 0px;
        left: 0px;
        right: 0px;

        img {
          width: 50px;
          margin-top: -35px;
        }
      }

      .card-wrapper {
        width: 100%;
        height: 45px;
        overflow: hidden;

        .w-card {
          border: 0px;
          height: 120px;
          border-radius: 200px;
        }
      }

    }

    .registration-content {
      // padding-top: 10px;
      position: relative;
      background: #FFF;
      min-height: 140px;
    }
  }

  div.loading {
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background: inherit;
  }

</style>

<style lang="scss">

  html {
    font-size: 62.5%;
  }

  body {
    margin: 0px;
    padding: 0px;
    font-size: 1.2rem;
    // font-size: 62.5%;
  }

  .registration-background {
    /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#46a0ef+0,46a0ef+40,6d7ef2+79 */
    background: #46a0ef; /* Old browsers */
    background: -moz-linear-gradient(45deg, #46a0ef 0%, #46a0ef 40%, #6d7ef2 79%); /* FF3.6-15 */
    background: -webkit-linear-gradient(45deg, #46a0ef 0%,#46a0ef 40%,#6d7ef2 79%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(45deg, #46a0ef 0%,#46a0ef 40%,#6d7ef2 79%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#46a0ef', endColorstr='#6d7ef2',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */

    /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#46a0ef+0,46a0ef+34,6e90f5+100 */
    // background: #46a0ef; /* Old browsers */
    // background: -moz-linear-gradient(45deg, #46a0ef 0%, #46a0ef 34%, #6e90f5 100%); /* FF3.6-15 */
    // background: -webkit-linear-gradient(45deg, #46a0ef 0%,#46a0ef 34%,#6e90f5 100%); /* Chrome10-25,Safari5.1-6 */
    // background: linear-gradient(45deg, #46a0ef 0%,#46a0ef 34%,#6e90f5 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    // filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#46a0ef', endColorstr='#6e90f5',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
  }

  // * {
    // font-size: 0.9rem;
    // color: #4C515A;
  // }

  @font-face {
    font-family: 'Material Icons';
    font-style: normal;
    font-weight: 400;
    src: local('Material Icons'),
      local('MaterialIcons-Regular'),
      url(/registrations/static/fonts/MaterialIcons-Regular.woff2) format('woff2'),
      url(/registrations/static/fonts/MaterialIcons-Regular.woff) format('woff'),
      url(/registrations/static/fonts/MaterialIcons-Regular.ttf) format('truetype');
  }

  .material-icons {
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 24px;  /* Preferred icon size */
    display: inline-block;
    line-height: 1;
    text-transform: none;
    letter-spacing: normal;
    word-wrap: normal;
    white-space: nowrap;
    direction: ltr;

    /* Support for all WebKit browsers. */
    -webkit-font-smoothing: antialiased;
    /* Support for Safari and Chrome. */
    text-rendering: optimizeLegibility;

    /* Support for Firefox. */
    -moz-osx-font-smoothing: grayscale;

    /* Support for IE. */
    font-feature-settings: 'liga';
  }

  // Test utilities
  .w-center { text-align: center; }
  .w-left   { text-align: left;   }
  .w-right  { text-align: right;  }

  .icon.w-dropdown-indicator {
    opacity: 0.5;
    margin: 0px;
    margin-top: 3px;
    font-size: 20px;
  }

  .w-ellipsis {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

</style>



// WEBPACK FOOTER //
// App.vue?aa6d8328